// NPM Imports
import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function NavBarItem(props) {
  const { item } = props;
  return (
    <Link
      data-test={`top-navbar-item-${item.name}`}
      to={item.link}
      className={`navbar-item ${
        props.location.pathname.includes(item.link) ||
        (props.location.pathname === "/templates" &&
          item.link === "/templates/library")
          ? "active"
          : ""
      }`}
      id={`top-navbar-item-${item.name}`}>
      {/* below span has been added for the notifications count only 
        {item.name === "INBOX" && props.newNotification ? (
          <span className="navbar-inbox-notificationdot" />
        ) : null} */}
      <i className="navbar-icon">
        <FontAwesomeIcon icon={["far", `${item.ico}`]} />
      </i>
      <span className="navbar-title">{item.tooltip}</span>
    </Link>
  );
}



// WEBPACK FOOTER //
// ./src/components/NavBarWrapper/NavBar/NavBarItem.js